module.exports = __webpack_public_path__ + "static/media/going-away-kin.5065f98b.jpg";